import { Data, Array, Tuple } from 'effect';
import * as Handedness from '../handedness';
export class GetAttachmentsError extends Data.TaggedError('@fixtuur/backpack/FixtuurAspectConfigurationSetService/GetAttachmentsError') {
}
const emptyHandednessResult = [[], Handedness.intersectionMonoid.empty];
const handednessResultErrors = Tuple.getFirst;
const handednessResultValue = Tuple.getSecond;
const combineHandednessResults = (left, right) => [
    handednessResultErrors(left).concat(handednessResultErrors(right)),
    Handedness.intersectionMonoid.combine(handednessResultValue(left), handednessResultValue(right)),
];
export const reduceHandednessResults = Array.reduce(emptyHandednessResult, combineHandednessResults);
